export default "<payment-partners\n  model=\"vm.model.acceptDepositsCertainBlackOrWhiteListInclude\"\n  form=\"vm.form\">\n</payment-partners>\n";